export default "__VITE_ASSET__DHUdIMwE__"